<template>
  <div>
    <pack-info :packId="packId" :showMenu="true"></pack-info>
    <v-container fluid>
      <search></search>
    </v-container>
  </div>
</template>

<script>
import PackInfo from "@/components/packInfo";
import Search from "@/components/search";

export default {
  name: "testPlanList",
  components: {
    PackInfo,
    Search,
  },
  computed: {
    packId() {
      return this.$route.params.packId;
    },
  },
};
</script>
